import { AxiosResponse } from "axios";
import {
  deleteRequest,
  getRequest,
  postRequest
} from "services/client/request";
import { NewNotification, Notification } from "types/Notification";

const apiVersion = "/api/v1";

export const getNotifications = async (
  accessToken: string,
  businessId: string
): Promise<Notification[]> => {
  const response: AxiosResponse<Notification[]> = await getRequest(
    `${apiVersion}/business/${businessId}/notifications`,
    accessToken
  );

  return response.data;
};

export const createNotification = async (
  request: NewNotification,
  accessToken: string,
  businessId: string
): Promise<void> => {
  try {
    await postRequest(
      `${apiVersion}/business/${businessId}/notification`,
      accessToken,
      {
        ...request,
        send_to_customers: true
      }
    );
  } catch (error) {
    if (typeof error === "object" && error !== null && "response" in error) {
      const serverError = error as { response: { data: { message: string } } };
      const errorMessage = serverError.response.data.message;
      alert(errorMessage);
    } else {
      alert("Created Failed");
    }
  }
};

export const sendNotification = async (
  request: NewNotification,
  accessToken: string,
  businessId: string
): Promise<void> => {
  await postRequest(
    `${apiVersion}/business/${businessId}/notification`,
    accessToken,
    request
  );
};

export const deleteNotificationApi = async (
  accessToken: string,
  businessId: string,
  notificationId: string
): Promise<void> => {
  await deleteRequest(
    `${apiVersion}/business/${businessId}/notification/${notificationId}`,
    accessToken
  );
};
